import {
    Swiper, Navigation,
} from 'swiper/swiper.esm';

Swiper.use([Navigation]);

const config = {
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    speed: 500,
    shortSwipes: false,
    freeMode: true,
    freeModeMomentumRatio: 0.3,
    preventClicks: false,
    preventClicksPropagation: false,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    slidesPerView: 2,
    slidesPerGroup: 2,
    breakpoints: {
        768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
        },
        1024: {
            slidesPerView: 4,
            slidesPerGroup: 4,
        },
    },
};

const RelatedContent = () => {
    // eslint-disable-next-line no-new
    const swiper = new Swiper('.content-carousel', config);
    if (swiper.slides) {
        const noVisible = swiper.slides.filter(s => !s.classList.contains('swiper-slide-visible'));
        if (!noVisible.length) {
            swiper.$el[0].classList.add('hide-nav');
        }
    }
};

export default RelatedContent;
